  document.addEventListener('DOMContentLoaded', function () {
    function initGoddessTestimonials() {
      document.querySelectorAll('.testimonials-goddess').forEach((section) => {
        const slider = section.querySelector('.testimonial-slider');
        const goddessProgressBar = section.querySelector('.goddessProgressBar');

        if (!slider || !goddessProgressBar) return;

        const isMobile = window.innerWidth <= 768;

        if (isMobile && !$(slider).hasClass('slick-initialized')) {
          $(slider).on('init', function (event, slick) {
            // ✅ Set initial progress correctly
            const progress = (1 / slick.slideCount) * 100;
            goddessProgressBar.style.width = progress + '%';
          });

          $(slider).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            infinite: false,
            adaptiveHeight: true,
          });

          // ✅ Update progress on slide change
          $(slider).on('afterChange.goddessSlider', function (event, slick, currentSlide) {
            const progress = ((currentSlide + 1) / slick.slideCount) * 100;
            goddessProgressBar.style.width = progress + '%';
          });
        }

        // Destroy on desktop
        if (!isMobile && $(slider).hasClass('slick-initialized')) {
          $(slider).slick('unslick');
          goddessProgressBar.style.width = '0%';
        }
      });
    }

    initGoddessTestimonials();

    // Debounced resize
    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(initGoddessTestimonials, 200);
    });
  });